import { render, staticRenderFns } from "./ReviewSitesAdmin.vue?vue&type=template&id=8d99a682"
import script from "./ReviewSitesAdmin.vue?vue&type=script&lang=js"
export * from "./ReviewSitesAdmin.vue?vue&type=script&lang=js"
import style0 from "./ReviewSitesAdmin.vue?vue&type=style&index=0&id=8d99a682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports